import PlainCheckbox from './plain-checkbox';

export default PlainCheckbox;
